import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Calculator from "./calculators/calculator";
import BrokerDashboard from "../pages/BrokerDashboard";
import BrokerCRM from "./BrokerCRM/BrokerCRM";
import Login from "./BrokerCRM/Login";
import RefinanceForm from "./RefinanceForm/RefinanceForm";

import WelcomeChoice from "./WelcomeChoice";
import ClientFormFlow from "./ClientForm/ClientFormFlow";

import CalculatorList from "../helpers/calculatorList";

function App() {
  return (
    <Router>
      <Routes>
        {/* Default = Borrowing Capacity Calculator */}
        <Route path="/" element={<Navigate to="/calculators" replace />} />

        {/* Broker CRM login */}
        <Route path="/login" element={<Login />} />

        {/* Broker CRM */}
        <Route path="/crm" element={<BrokerCRM />} />

        {/* Separate dashboard page */}
        <Route path="/dashboard" element={<BrokerDashboard />} />

        {/* Optional old broker alias */}
        <Route path="/broker" element={<Navigate to="/dashboard" replace />} />

        {/* Start page */}
        <Route path="/apply" element={<WelcomeChoice />} />

        {/* Purchase */}
        <Route path="/purchase" element={<ClientFormFlow />} />

        {/* Backwards compatible alias */}
        <Route path="/welcome" element={<Navigate to="/purchase" replace />} />

        {/* Refinance */}
        <Route path="/refinance" element={<RefinanceForm />} />

        {/* Calculators - Borrowing Capacity default */}
        <Route
          path="/calculators"
          element={<Calculator selectedCalc={CalculatorList.borrowingCapacity} />}
        />
      </Routes>
    </Router>
  );
}

export default App;